"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingHelpers = void 0;
var track_blur_1 = require("../actions/track_blur");
var track_click_1 = require("../actions/track_click");
var track_error_1 = require("../actions/track_error");
var track_metric_1 = require("../actions/track_metric");
var track_search_1 = require("../actions/track_search");
var track_view_1 = require("../actions/track_view");
var TrackingHelpers = function (environmentName, applicationId) {
    var bindArgs = function (method) {
        return method.bind(null, environmentName, applicationId);
    };
    return {
        // views
        trackView: bindArgs(track_view_1.trackView),
        trackRecommendationsView: bindArgs(track_view_1.trackRecommendationsView),
        trackCartView: bindArgs(track_view_1.trackCartView),
        // clicks
        trackClick: bindArgs(track_click_1.trackClick),
        trackRecommendationClick: bindArgs(track_click_1.trackRecommendationClick),
        trackCartClick: bindArgs(track_click_1.trackCartClick),
        // blurs
        trackBlur: bindArgs(track_blur_1.trackBlur),
        // metrics
        trackMetric: bindArgs(track_metric_1.trackMetric),
        // errors
        trackError: bindArgs(track_error_1.trackError),
        // searches
        trackSearch: bindArgs(track_search_1.trackSearch),
    };
};
exports.TrackingHelpers = TrackingHelpers;
